import { render, staticRenderFns } from "./Artist.vue?vue&type=template&id=26024952&scoped=true"
import script from "./Artist.vue?vue&type=script&lang=js"
export * from "./Artist.vue?vue&type=script&lang=js"
import style0 from "./Artist.vue?vue&type=style&index=0&id=26024952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26024952",
  null
  
)

export default component.exports